import { Codificacion } from "./codificacion";

export class CodificacionDefault extends Codificacion {
    codDefault: boolean;

	constructor(element=null) {
		super();

		if(!element)
			return;

		this.codDefault = element.codDefault;
	}
}